var app_dayparts_table = $('#app-dayparts-table');

if (app_dayparts_table.length) {
    var data_table_order=[8, "desc"];
    var daypartsTableObj = null;
    function initializeDaypartsTable() {
        console.log('$$$$$$$$$$$$$$$$$ ', user_entries, data_table_order);
        daypartsTableObj = window.app_dayparts_table
            .DataTable({
                ajax: {
                    url: '/dayparts/list',
                    dataSrc: 'data'
                    },
                columns: [
                    {data: 'type'},//0
                    {data: 'abbreviation'},//1
                    {data: 'name'},//2
                    {
                        data: 'programs',
                        render: function(data, type, row) {
                            if (row.main === 2 && Array.isArray(data)) {
                                return data.join(' / ');
                            } else {
                                return data;
                            }
                        }
                    },//3
                    {data: 'dows'},//4
                    {data: 'time_period'},//5
                    {data: 'category_name'},//6
                    {data: 'daypart_type'},//7
                    {data: 'updated_at'},//8
                    {data: 'slug'}//9
                ],
                pageLength: user_entries,
                order: data_table_order,
                destroy: true,
                "columnDefs": [{
                    "targets": 0,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        if (cellData === 'tv')
                            $(td).html('Television');
                        else if (cellData === 'cable')
                            $(td).html('Cable');
                        else
                           $(td).html('Digital');

                    }
                },{
                    "targets": 3,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        if (rowData.main === 2)
                            $(td).html();
                        else
                            $(td).html('-------');
                    }
                },{
                    "targets": 4,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        $(td).html();
                    }
                }, {
                    "targets": 5,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        if (rowData.main === 2)
                            $(td).html('-------');
                        else
                            $(td).html();


                    }
                }, {
                    "targets": 6,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        if (rowData.main === 2)
                            $(td).html('-------');
                        else
                            $(td).html();

                    }
                }, {
                        "targets": 7,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            if (rowData.main === 1)
                                $(td).html('Traditional');
                            else if (rowData.main === 0)
                                $(td).html('Custom');
                            else
                                $(td).html('Program Group');
                          //  console.log('rowData_rowData_rowData ', rowData.main, $(td).html());
                        }
                    },{
                    "targets": 8,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        $(td).html(moment(cellData).format('MM/DD/YYYY'));
                    }
                },{
                    "targets": 9,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var html = '';
                        var deleteButton = ''
                        if (rowData.agency_id !== 0 && rowData.main !== 1) {
                            // var html = '<div class="row text-center"><div class="btn-group" role="group">' +
                            //     '<a href="/dayparts/' +
                            //     cellData +
                            //     '/edit" role="button" class="btn btn-success btn-sm">' +
                            //     '<i class="fa fa-pencil"></i> Edit ' +
                            //     '</a>' +
                            //     '</div>';

                            if(table_editable){
                                deleteButton += '<li class="ms-hover"><a href="javascript:void(0)" onclick="deleteDaypart(\'' + cellData + '\')" role="button" class="btn btn-danger btn-sm">' +
                                    '<i class="fa fa-trash-o"></i> Delete ' +
                                    '</a></li>';
                            }

                            html += '</div>';

                            var html = '<div class="btn-group">\n' +
                                '            <button type="button" class="btn btn-outline btn-success waves-effect waves-light m-r-5 btn-off" data-toggle="dropdown">\n' +
                                '                <i class="fa fa-ellipsis-v"></i>\n' +
                                '                <span class="sr-only">Toggle Dropdown</span>\n' +
                                '            </button>\n' +
                                '            <ul class="dropdown-menu dropdown-menu-right">\n' +
                                '                <li class="ms-hover">' + '<a href="/dayparts/' + cellData + '/edit" role="button" class="btn btn-success btn-sm">' + '<i class="fa fa-pencil"></i> Edit ' + '</a>' + '</li>\n' +
                                deleteButton + '\n' +
                                '                <li role="separator" class="divider ms-hover"></li>\n' +
                                '                <li class="ms-hover"><a href="javascript::;"></a></li>\n'
                            '            </ul>\n' +
                            '        </div>';
                        }
                        $(td).html(html);
                    }
                }]
            });
    }

    var daypart_type_selector = '';
    $.fn.dataTable.ext.search.push(
        function( settings, data, dataIndex ) {
            console.log('ROW DATA: ', data, dataIndex)
            var currentData = daypartsTableObj.data();
            if (daypart_type_selector !== '' && ((daypart_type_selector === 'Traditional' && currentData[dataIndex].main !== 1) || (daypart_type_selector !== 'Traditional' && currentData[dataIndex].main === 1))) {
                return false;
            }
            else {
                return true;
            }
        }
    );

    function filterByDaypartType () {
        daypart_type_selector = String($('#daypart_type_selector').val());
        daypartsTableObj.draw();
    }

    $('#app-dayparts-table').on( 'length.dt', function ( e, settings, len ) {
        user_entries= len;
    });
    $('#app-dayparts-table').on( 'order.dt', function ( e, settings, len) {
        data_table_order=[len[0].col, ""+len[0].dir+""];
    } );


    function deleteDaypart(urlVar) {
        $('#deleteDaypartConfirmed').attr('data-url', urlVar);
        $('#deleteDaypartWarningModal').modal('show');
    }
    function deleteDaypartConfirmed() {
        var urlVar = $('#deleteDaypartConfirmed').attr('data-url');
        show_loader();
        $.ajax({
            url: '/dayparts/' + urlVar + '/destroy',
            success: function (response) {
                global_notification('success', 'Daypart deleted.')
                initializeDaypartsTable();
                $('#deleteDaypartWarningModal').modal('hide');
                hide_loader();
            },
            error: function (xhr) {
                if (xhr.status === 422) {
                    global_notification('warning', xhr.responseJSON.message);
                } else {
                    ajax_error();
                    debug(xhr.responseText);
                }
                hide_loader();
            }
        });
    }

    initializeDaypartsTable();
}
